import styled from "@emotion/styled"
import HubspotForm from "components/HubspotForm"

const GateForContentFirstStage = styled(HubspotForm)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    display: contents;
  }
`

export default GateForContentFirstStage
